module.exports = __webpack_public_path__ + "img/4.ef4bc5ac.png";